import { FaStar } from 'react-icons/fa';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export default function Testimonials() {
  const testimonials = [
    {
      id: 1,
      name: 'Rajesh Kumar',
      role: 'Property Buyer',
      image: 'https://ui-avatars.com/api/?name=Rajesh+Kumar&background=3b82f6&color=fff&size=128',
      rating: 5,
      text: 'P&M Dream Manors helped me find my perfect home in Mumbai. Their team was professional, transparent, and made the entire process stress-free. Highly recommended!',
    },
    {
      id: 2,
      name: 'Priya Sharma',
      role: 'Property Seller',
      image: 'https://ui-avatars.com/api/?name=Priya+Sharma&background=ec4899&color=fff&size=128',
      rating: 5,
      text: 'Excellent service! They sold my property within 2 weeks at a great price. The team was always available to answer my questions. Very satisfied with their work.',
    },
    {
      id: 3,
      name: 'Amit Patel',
      role: 'Tenant',
      image: 'https://ui-avatars.com/api/?name=Amit+Patel&background=10b981&color=fff&size=128',
      rating: 5,
      text: 'Found an amazing rental apartment through P&M Dream Manors. The property was exactly as described, and the landlord connection process was seamless. Thank you!',
    },
    {
      id: 4,
      name: 'Sneha Reddy',
      role: 'First-time Buyer',
      image: 'https://ui-avatars.com/api/?name=Sneha+Reddy&background=f59e0b&color=fff&size=128',
      rating: 5,
      text: 'As a first-time buyer, I was nervous about the process. The team guided me through every step and helped me find a property within my budget. Truly grateful!',
    },
    {
      id: 5,
      name: 'Vikram Singh',
      role: 'Investor',
      image: 'https://ui-avatars.com/api/?name=Vikram+Singh&background=8b5cf6&color=fff&size=128',
      rating: 5,
      text: 'Invested in multiple properties through P&M Dream Manors. Their market knowledge and professional approach make them the best real estate partner in India.',
    },
  ];

  return (
    <div className="bg-gray-50 py-16">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-gray-600 text-lg">
            Trusted by thousands of happy homeowners
          </p>
        </div>

        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="pb-12"
        >
          {testimonials.map((testimonial) => (
            <SwiperSlide key={testimonial.id}>
              <div className="bg-white p-6 rounded-lg shadow-lg h-full flex flex-col">
                <div className="flex items-center gap-4 mb-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div>
                    <h3 className="font-semibold text-lg">{testimonial.name}</h3>
                    <p className="text-gray-600 text-sm">{testimonial.role}</p>
                  </div>
                </div>

                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-400" />
                  ))}
                </div>

                <p className="text-gray-700 italic flex-grow">"{testimonial.text}"</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
